export enum AssignmentStatus {
    CREATED = 'Auftrag angelegt',
    IN_PROGRESS = 'Auftrag in Arbeit',
    STOPPED = 'Auftrag gestoppt',
    COMPLETED = 'Auftrag abgeschlossen'
}
